import qs from 'qs';
import { ProcurementsDisplay, CallOffsSubCategory } from './types';
import { Paths } from 'src/pages/paths';
import { router } from 'src';
import { FileExt } from 'src/types/file';
import {
  IApiBoxField,
  IBoxField,
  IBoxFieldArray,
  IBoxFieldBoolean,
  IBoxFieldCurrency,
  IBoxFieldDate,
  IBoxFieldDateRange,
  IBoxFieldEmail,
  IBoxFieldNumber,
  IBoxFieldRange,
  IBoxFieldString,
  IBoxFieldUrl
} from './Tender/types';
import { BoxFieldCurrencyRange } from '.';

export function isProcurementDisplay(u: unknown): u is ProcurementsDisplay {
  return typeof u === 'string' && Object.values(ProcurementsDisplay).some(v => v === u);
}
export function isCallOffSubCategory(u: unknown): u is CallOffsSubCategory {
  return typeof u === 'string' && Object.values(CallOffsSubCategory).some(v => v === u);
}

export function generateOverviewPathFromQp(qp: Record<string, unknown>): string {
  const newQPFiltered = Object.fromEntries(Object.entries(qp).filter(([, v]) => v !== null && v !== undefined));
  return `${Paths.PROCUREMENT_TABLE_PAGE /*history.location.pathname*/}?${qs.stringify(newQPFiltered)}`;
}

export function isTenderPage(): boolean {
  return Paths.TENDER_PAGE.split('/')[1] === router.state.location.pathname.split('/')[1];
}

const PREVIEW_FILE_EXT = [FileExt.pdf, FileExt.docx];
const CONVERT_FILE_EXT = [FileExt.docx];
export function isPreviewableFile(fileExt: string): boolean {
  return fileExt in FileExt && PREVIEW_FILE_EXT.includes(fileExt as FileExt);
}

export function isConvertableFile(fileExt: string): boolean {
  return fileExt in FileExt && CONVERT_FILE_EXT.includes(fileExt as FileExt);
}

export function getFileNameFromPath(filePath: string): string {
  return filePath.substring(filePath.lastIndexOf('/') + 1, filePath.length);
}

// TODO: move to Field model in PROM-3142
export function toCorrectEmail(email: string): string {
  if (!email) return '';
  const MAIL_TO = 'mailto:';
  return email.startsWith(MAIL_TO) ? email : `${MAIL_TO}${email}`;
}

export function fieldFilter(field?: IApiBoxField | IBoxField): boolean {
  return (
    !!(field as IBoxFieldArray).array ||
    ((field as IBoxFieldBoolean).boolean !== undefined && (field as IBoxFieldBoolean).boolean !== null) ||
    !!(field as IBoxFieldNumber).number ||
    !!(field as IBoxFieldCurrency).amount ||
    !!(field as IBoxFieldCurrency).currency ||
    !!(field as BoxFieldCurrencyRange).from ||
    !!(field as BoxFieldCurrencyRange).to ||
    !!(field as IBoxFieldDate).date ||
    !!(field as IBoxFieldDateRange).from ||
    !!(field as IBoxFieldDateRange).to ||
    !!(field as IBoxFieldRange).from ||
    !!(field as IBoxFieldRange).to ||
    !!(field as IBoxFieldString).string ||
    !!(field as IBoxFieldUrl).url ||
    !!(field as IBoxFieldEmail).email
  );
}
